import { Injectable } from '@angular/core';

import { Error } from '../models/error.model';

@Injectable()
export class ErrorService {
  private readonly errorKey: string = 'error';
  constructor() {}

  public SetErrorData(response: any): void {
    let error: Error;
    if (response.status < 500) {
      error = {
        code: response.status,
        message: response.error,
        id: undefined
      };
    } else {
      error = {
        code: response.error.Code,
        message: response.error.Message,
        id: response.error.Id
      };
    }

    localStorage.setItem(this.errorKey, JSON.stringify(error));
  }

  public GetErrorData(): Error {
    const error = JSON.parse(localStorage.getItem(this.errorKey));
    localStorage.removeItem(this.errorKey);

    return error;
  }
}
